import { render } from "./Produits.vue?vue&type=template&id=2ff79422&scoped=true"
import script from "./Produits.vue?vue&type=script&lang=js"
export * from "./Produits.vue?vue&type=script&lang=js"

import "./Produits.vue?vue&type=style&index=0&id=2ff79422&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ff79422"]])

export default __exports__